
import { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  badgeText: string;
  badgeColor?: string;
  subtitle?: string;
}

const StatsCard = ({ 
  title, 
  value, 
  icon, 
  badgeText, 
  badgeColor = "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100",
  subtitle
}: StatsCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-gray-500 dark:text-gray-400">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center">
          {icon}
          <span className="text-2xl font-bold">{value}</span>
          <Badge className={`ml-2 ${badgeColor}`}>
            {badgeText}
          </Badge>
        </div>
        {subtitle && <p className="text-sm text-gray-500 mt-2">{subtitle}</p>}
      </CardContent>
    </Card>
  );
};

export default StatsCard;
